import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button } from '@node-space/ui-components'

export interface AddCustomerActionsProps {
  onConfirmDetails?: () => void
  onCancel: () => void
}

export const AddCustomerActions = ({ onConfirmDetails, onCancel }: AddCustomerActionsProps) => {
  const { t } = useTranslation()

  return (
    <Box flex justify="between" paddingT={24}>
      <Button onClick={onCancel} variant="secondary">
        {t('cancel')}
      </Button>
      {onConfirmDetails ? (
        <Button onClick={onConfirmDetails}>{t('confirm')}</Button>
      ) : (
        <Button type="submit">{t('continue')}</Button>
      )}
    </Box>
  )
}
